import React from "react";
import { GlassCardSurface, HudCorner } from "./AboutMe.styles";

interface GlassCardInnerProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const GlassCardInner: React.FC<GlassCardInnerProps> = ({
  children,
  style
}) => (
  <GlassCardSurface style={style}>
    <HudCorner $pos="tl" />
    <HudCorner $pos="tr" />
    <HudCorner $pos="bl" />
    <HudCorner $pos="br" />
    {children}
  </GlassCardSurface>
);
